import Button from 'common/components/Button/Button';
import React from 'react';
import { Trans } from 'react-i18next';
import sdk from 'sdk';
import { createUseStyles } from 'react-jss';
import ReactSVG from 'react-svg';
import Variables from 'Variables.styles';
import gtmTrack, { iEventNames, iEventTypes } from 'common/hooks/gtmTrack/gtmTrack';
import { secureRedirect } from 'utils/secureRedirect';
import config from '../../config/app';
import google from '../../assets/svg/sso/icon-google.svg';
import apple from '../../assets/svg/sso/icon-apple-logo.svg';

const useStyles = createUseStyles({
  container: {
    paddingTop: Variables.medium,
    textAlign: 'center',
  },
  buttonsContainer: {
    display: 'flex',
    gap: Variables.large,
  },
  orTextContainer: {
    marginBottom: Variables.medium,
    color: Variables.gray600,
    fontWeight: '500',
  },
  ssoButtonGoogle: {
    backgroundColor: Variables.white,
    color: Variables.gray600,
    marginBottom: Variables.medium,
    display: 'flex',
    justifyContent: 'center',
  },
  ssoButtonApple: {
    backgroundColor: Variables.black,
    marginBottom: Variables.medium,
    display: 'flex',
    justifyContent: 'center',
  },
  icon: {
    color: Variables.gray600,
  },
  iconApple: {
    color: Variables.white,
  },
});

const SsoButtons = ({ islogin = false }) => {
  const classes = useStyles();
  const topLabel = islogin ? ' login with' : 'sign up with';
  const clickEventPayload = {
    event: iEventNames.start_sign_up,
    event_type: iEventTypes.custom,
    eventData: {
      signup_provider: '',
    },
  };

  const onRegisterGoogle = () => {
    const trackingPayload = { ...clickEventPayload, ...{ event_data: { signup_provider: 'Google' } } };
    if (typeof window !== 'undefined') {
      const googleAuthUrl = `${config.API_ENDPOINT}auth/google`;
      secureRedirect(googleAuthUrl); // nosemgrep: javascript.browser.security.open-redirect.js-open-redirect
      gtmTrack('trackEvent', trackingPayload);
    }
  };

  const onRegisterApple = async () => {
    const trackingPayload = { ...clickEventPayload, ...{ event_data: { signup_provider: 'Apple' } } };
    try {
      const { appleSsoRedirectUrl } = await sdk.AppleSsoApi.getAuthoriseUrl();
      if (appleSsoRedirectUrl) {
        secureRedirect(appleSsoRedirectUrl); // nosemgrep: javascript.browser.security.open-redirect.js-open-redirect
        gtmTrack('trackEvent', trackingPayload);
      }
    } catch (err) {
      const { message } = err;
      window.cakepool.showAlert('error', <span><Trans>Error</Trans>: <Trans>{message}</Trans></span>);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.orTextContainer}><Trans>Or {topLabel}</Trans></div>
      <div className={classes.buttonsContainer}>
        <Button
          className={classes.ssoButtonGoogle}
          primary
          block
          type="button"
          onClick={() => onRegisterGoogle()}
        >
          <ReactSVG src={google} className={classes.icon} />
        </Button>
        <Button
          className={classes.ssoButtonApple}
          primary
          block
          type="button"
          onClick={() => onRegisterApple()}
        >
          <ReactSVG src={apple} className={classes.iconApple} />
        </Button>
      </div>
    </div>
  );
};

export default SsoButtons;
